import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/store/hooks";
import { currentMediaShareSelector } from "@/store/selectors";
import { getCurrentMediaShare, updateCurrentMediaShareOpened } from "@/store/v2/currentMediaShare/actions";

import { useUrlParams } from "./useUrlParams";

export function useCurrentMediaShare() {
  const dispatch = useThunkDispatch();
  const currentMediaShare = useSelector(currentMediaShareSelector);
  const { propertyId, experienceId, shareId } = useUrlParams();

  const hookEnabled = shareId && !isNaN(+shareId) && !experienceId;

  function fetchCurrentMediaShare() {
    if (propertyId && shareId) {
      dispatch(getCurrentMediaShare(+propertyId, +shareId));
    }
  }

  useEffect(() => {
    if (hookEnabled) {
      fetchCurrentMediaShare();
    }
  }, [hookEnabled, propertyId, shareId]);

  useEffect(() => {
    if (propertyId && hookEnabled && currentMediaShare.mediaShare?.hasOpened === false) {
      dispatch(updateCurrentMediaShareOpened(+propertyId, +shareId, !currentMediaShare.mediaShare?.hasOpened));
    }
  }, [currentMediaShare.mediaShare?.hasOpened]);
}
